import { isDefined } from "@omni/utils/helper.utils";
import { RefObject, useEffect, useRef } from "react";

import { Config } from "@/utils/config.utils";
import { DamImage } from "@/utils/dam.utils";

import { ZOOM_BREAKPOINT } from "../storeSearch.config";
import { useMap } from "./useMap.hook";

export const useStoresOverlay = (
    mapElementRef: RefObject<HTMLDivElement | null>
) => {
    const storeOverlayRef = useRef<woosmap.map.StoresOverlay | null>(null);

    const map = useMap(mapElementRef);

    useEffect(() => {
        if (!isDefined(map)) return;

        storeOverlayRef.current = new woosmap.map.StoresOverlay({
            breakPoint: ZOOM_BREAKPOINT,
            rules: [],
            default: {
                color: "#B90000",
                size: 6,
                minSize: 1,
                icon: {
                    url: DamImage.icon.maps.marker(),
                    scaledSize: {
                        height: 27,
                        width: 22
                    }
                }
            }
        });
        storeOverlayRef.current.setMap(map);
        storeOverlayRef.current.setQuery(
            `user.locale:="${Config.getLocale()}"`
        );
    }, [map]);

    const setMapQuery = (query: string | undefined) => {
        storeOverlayRef.current?.setQuery(query);
    };

    const setMapSelection = (selection: object) => {
        storeOverlayRef.current?.setSelection(selection);
    };

    const clearMapSelection = () => {
        storeOverlayRef.current?.clearSelection();
    };

    return {
        setMapQuery: setMapQuery,
        setMapSelection: setMapSelection,
        clearMapSelection: clearMapSelection
    };
};
